import { Pipe, PipeTransform } from '@angular/core';

import { Country } from '../../countries/shared';
import { Reseller } from './reseller.model';

@Pipe({
  name: 'resellerFilter'
})
export class ResellerFilterPipe implements PipeTransform {
  transform(resellers: Array<Reseller>, name: string, type: number, country: String): any {
    if (resellers) {
      console.log(country);
      return resellers.filter((reseller: Reseller) => {
        let valid = true;

        if (
          (name) &&
          (reseller.name.toLowerCase().lastIndexOf(name.toLowerCase(), 0) !== 0)
        ) {
          valid = false;
        }

        if ((type) && (type > 0) && (reseller.type !== type)) {
          valid = false;
        }



        if ((country) && (reseller.country._id !== country)) {
          valid = false;
        }

        return valid;
      });
    }

    return resellers;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/resellers/shared/reseller-filter.pipe.ts